/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeatmapRow
 */
export interface HeatmapRow {
    /**
     * 
     * @type {string}
     * @memberof HeatmapRow
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatmapRow
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatmapRow
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof HeatmapRow
     */
    compositeDesigned?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatmapRow
     */
    compositeOperational?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatmapRow
     */
    compositeValidated?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatmapRow
     */
    operationalGap?: number;
    /**
     * 
     * @type {string}
     * @memberof HeatmapRow
     */
    colorBucket?: string;
}

/**
 * Check if a given object implements the HeatmapRow interface.
 */
export function instanceOfHeatmapRow(value: object): value is HeatmapRow {
    return true;
}

export function HeatmapRowFromJSON(json: any): HeatmapRow {
    return HeatmapRowFromJSONTyped(json, false);
}

export function HeatmapRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeatmapRow {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'compositeDesigned': json['compositeDesigned'] == null ? undefined : json['compositeDesigned'],
        'compositeOperational': json['compositeOperational'] == null ? undefined : json['compositeOperational'],
        'compositeValidated': json['compositeValidated'] == null ? undefined : json['compositeValidated'],
        'operationalGap': json['operationalGap'] == null ? undefined : json['operationalGap'],
        'colorBucket': json['colorBucket'] == null ? undefined : json['colorBucket'],
    };
}

export function HeatmapRowToJSON(json: any): HeatmapRow {
    return HeatmapRowToJSONTyped(json, false);
}

export function HeatmapRowToJSONTyped(value?: HeatmapRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'capabilityDomain': value['capabilityDomain'],
        'compositeDesigned': value['compositeDesigned'],
        'compositeOperational': value['compositeOperational'],
        'compositeValidated': value['compositeValidated'],
        'operationalGap': value['operationalGap'],
        'colorBucket': value['colorBucket'],
    };
}

